import { postFedExDetails } from '@Reducers/AdminShipment/actions';
import { AppDispatch } from '@Store';
import dayjs, { Dayjs } from 'dayjs';

export interface emiratesInformationSchema {
  csp: string;
  type: string;
  accountNo: string;
  countryOfManufacture: string;
  paymentMode: string;
  serviceType: string;
  dateOfBirth?: Dayjs | null;
  expiryDate?: Dayjs | null;
}

export const onForward = async ({
  values,
  shipmentNumber,
  dispatch,
  nextFunc,
  setLoading,
}: {
  values: emiratesInformationSchema;
  shipmentNumber: string;
  dispatch: AppDispatch;
  nextFunc: () => void;
  setLoading: React.Dispatch<React.SetStateAction<boolean>>;
}) => {
  try {
    setLoading(true);

    const body: any = { ...JSON.parse(JSON.stringify(values)) };
    body.csp = 'emirates_skycargo';

    for (const key in body) {
      if (body[key]) {
        if (key === 'accountNo') {
          if (Array.isArray(body[key])) {
            body[key] = body[key][0]?.value?.split('-')?.[0] || '';
          } else if (typeof body[key] === 'object' && body[key]?.value) {
            body[key] = body[key].value.split('-')?.[0] || '';
          } else if (typeof body[key] === 'string') {
            body[key] = body[key].split('-')?.[0];
          }
        }
        if (key === 'expiryDate') {
          body[key] = dayjs(values?.expiryDate).format('YYYY-MM-DD');
        }
        if (key === 'dateOfBirth') {
          body[key] = dayjs(values?.dateOfBirth).format('YYYY-MM-DD');
        }
      }
    }

    const response: any = await dispatch(
      postFedExDetails({
        shipmentNumber: `${shipmentNumber}`,
        body,
        date: null,
        nextFunc,
      }),
    );

    // call nextFunc only when success
    if (response.meta.requestStatus === 'fulfilled') {
      nextFunc();
    }
  } catch (error) {
    console.error('Error in onForward:', error);
  } finally {
    setLoading(false);
  }
};
